module.exports = __webpack_public_path__ + "io.svg?7fc155e7fac8126870876572461fe95b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/io.svg
// module id = 1165
// module chunks = 0